import React from 'react'

export const TabModules: React.FC = () => {
    return <>TabModules</>
}
